import { createLoader } from '@meteor/data-hooks';
import { authIntentState } from './authIntent';
import { authClient } from './client';

export let authState = createLoader({
  name: 'auth',
  hash: ai => 'auth',
  fetch: (d: {}) => {
    if (typeof window === 'undefined')
      throw new Error('Cannot fetch authIntent on the server');

    return authClient.authentication.boot({});
  },
  mutators: {
    start: async (
      data:
        | {
            type: 'email';
            email: string;
            redirectUrl: string;
          }
        | {
            type: 'oauth';
            provider: 'google' | 'github';
            redirectUrl: string;
          }
        | {
            type: 'session';
            userOrSessionId: string;
            redirectUrl: string;
          }
        | {
            type: 'internal';
            token: string;
            redirectUrl: string;
          },
      { input, output }
    ) => {
      let auth = await authClient.authentication.start(data);

      if (auth.type == 'hook') {
        window.location.replace(auth.url);

        // Will never resolve
        return new Promise<never>(() => {});
      } else if (auth.type == 'auth_attempt') {
        let session = await authClient.authAttempt.exchange({
          authAttemptId: auth.authAttempt.id,
          clientSecret: auth.authAttempt.clientSecret
        });

        window.location.replace(session.url);

        // Will never resolve
        return new Promise<never>(() => {});
      } else {
        await authIntentState.fetch({
          authIntentId: auth.authIntent.id,
          authIntentClientSecret: auth.authIntent.clientSecret
        });

        return auth.authIntent;
      }
    }
  }
});
